const getMsgReviews = ({ numberComments, numberReviews }: any) => {
  if (numberReviews == 1 && numberComments == 0) {
    return `${numberReviews} pessoa deu nota, mas nenhuma comentou.`;
  }
  if (numberReviews > 1 && numberComments == 0) {
    return `${numberReviews} pessoas deram nota, mas nenhuma comentou.`;
  }
  if (numberReviews > 1 && numberComments == 1) {
    return `${numberReviews} pessoas deram nota, 1 delas também comentou.`;
  }
  if (numberReviews == 1 && numberComments == 1) {
    return '1 pessoa deu nota e comentou.';
  }
  if (numberReviews == numberComments) {
    return `${numberReviews} pessoas deram nota e comentaram.`;
  }

  return `${numberReviews} pessoas deram nota, ${numberComments} delas também comentaram.`;
};

export default getMsgReviews;
export { getMsgReviews };
